import React, { useEffect, useState, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material/";
import classnames from "classnames";
import { makeStyles, useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import { PersonOutline, OpenInNew, ExitToApp, Dashboard } from "@mui/icons-material";
import MessagesIcon from "../../../../assets/icons/MessagesIcon.js";
import ContactsIcon from "../../../../assets/icons/ContactsIcon.js";
import CampaignIcon from "../../../../assets/icons/CampaignIcon.js";
import GroupsIcon from "../../../../assets/icons/GroupsIcon.js";
import SettingsIcon from "../../../../assets/icons/SettingsIcon.js";
import ReportsIcon from "../../../../assets/icons/ReportsIcon.js";
import UserStatus from "../../../../context/UserStatus";

import { green } from "../../../../constants/colors";

const useStyles = makeStyles((theme) => ({
  listItems: {
    padding: 0,
    backgroundColor: theme.palette.bg,
    color: theme.palette.mainText,
  },
  listItemContainer: {
    padding: 0,
    margin: 0,
    display: "flex",
    backgroundColor: theme.palette.toolbarBg,
  },
  listItemIcon: {
    margin: "5% 0 5% 0",
    height: "50px",
    width: "95%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  listItemIconBorder: {
    zIndex: 1000,
    width: "5%",
    borderTopLeftRadius: 18,
    borderBottomLeftRadius: 18,
  },
  icon: {
    color: theme.palette.mainText,
  },
  text: {
    "& .MuiTypography-body1": {
      fontFamily: "SFProText-Regular",
      fontSize: "16px",
      color: theme.palette.mainText,
    },
  },
  profileOption: {
    margin: 0,
    height: "35px",
    padding: "5px 0",
    overflow: "hidden",
    backgroundColor: "inherit",
    color: theme.palette.mainText,
  },
  profileOptionIcon: {
    padding: 0,
    margin: 0,
    height: "auto",
  },
}));

const Links = ({ showText, profileOptions, handleUserSettingClose, handleDrawerToggle }) => {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const [activeIcon, setActiveIcon] = useState(location.pathname || "/messages");
  const { t } = useTranslation();
  const UserContext = useContext(UserStatus);

  useEffect(() => {
    if (location.pathname !== activeIcon) setActiveIcon(location.pathname);
  }, [activeIcon, location.pathname]);

  const links = [
    {
      url: "/dashboard",
      icon: (
        <Dashboard
          style={{ color: activeIcon === "/dashboard" ? green : theme.palette.toolbarContent }}
        />
      ),
      text: t("Dashboard"),
      key: "/dashboard",
    },
    {
      url: "/messages",
      icon: (
        <MessagesIcon fill={activeIcon === "/messages" ? green : theme.palette.toolbarContent} />
      ),
      text: t("Messages"),
      key: "/messages",
    },
    {
      url: "/contacts",
      icon: (
        <ContactsIcon fill={activeIcon === "/contacts" ? green : theme.palette.toolbarContent} />
      ),
      text: t("Contacts"),
      key: "/contacts",
    },
    {
      url: "/groups",
      icon: <GroupsIcon fill={activeIcon === "/groups" ? green : theme.palette.toolbarContent} />,
      text: t("Groups"),
      key: "/groups",
    },
    {
      url: "/campaign",
      icon: (
        <CampaignIcon fill={activeIcon === "/campaign" ? green : theme.palette.toolbarContent} />
      ),
      text: t("Campaigns"),
      key: "/campaign",
    },
    {
      url: "/reports",
      icon: <ReportsIcon fill={activeIcon === "/reports" ? green : theme.palette.toolbarContent} />,
      text: t("Reports"),
      key: "/reports",
    },
    {
      url: "/settings/edit-profile",
      icon: (
        <SettingsIcon
          fill={activeIcon.includes("/settings") ? green : theme.palette.toolbarContent}
        />
      ),
      text: t("Settings"),
      key: "/settings/",
    },
  ];

  const profileOptionsArray = [
    {
      url: "/settings/account",
      icon: (
        <PersonOutline
          className={classnames(profileOptions ? classes.profileOptionIcon : null, classes.icon)}
        />
      ),
      text: t("My Account"),
      key: "my account",
    },
    {
      url: "/settings/edit-profile",
      icon: <OpenInNew className={classes.icon} />,
      text: t("Edit Profile"),
      key: "edit profile",
    },
    {
      url: "/",
      icon: <ExitToApp className={classes.icon} />,
      text: t("Logout"),
      key: "logout",
    },
  ];

  return (profileOptions ? profileOptionsArray : links).map(
    ({ component, url, icon, text, key }) => {
      return (
        <ListItem
          className={classnames(profileOptions ? classes.profileOption : null, classes.listItems)}
          component={NavLink}
          to={url}
          onClick={() => {
            if (handleUserSettingClose) handleUserSettingClose();
            setActiveIcon(key);
            return text === "Logout" || text === "تسجيل الخروج" ? UserContext.logout() : null;
          }}
          key={key}
        >
          <div
            className={classes.listItemContainer}
            style={{ width: profileOptions ? "auto" : "100%" }}
          >
            <Tooltip title={text} arrow placement="right" enterDelay={10} leaveDelay={10}>
              <ListItemIcon
                onClick={() => {
                  handleDrawerToggle();
                }}
                className={classes.listItemIcon}
              >
                {icon}
              </ListItemIcon>
            </Tooltip>
            <div
              style={{ backgroundColor: activeIcon.includes(key) ? green : "transparent" }}
              className={classes.listItemIconBorder}
            />
          </div>

          {showText ? <ListItemText className={classes.text} primary={text} /> : null}
          {component || null}
        </ListItem>
      );
    },
  );
};

export default Links;
